/** Ativar com EXPO_PUBLIC_MARKETING_MOCK=true no .env (reiniciar Metro após mudar). */
export function isMarketingMockEnabled(): boolean {
  return process.env.EXPO_PUBLIC_MARKETING_MOCK === 'true';
}
